import React from 'react';
import '../MarsTheme.css';

const SkillMeter = ({ skills }) => {
    return (
        <div className="skill-meter-container glass-panel fade-in">
            <h3 className="widget-title">System Capabilities</h3>
            <div className="skills-grid">
                {skills.map((skill, index) => (
                    <div key={skill.name} className="skill-item">
                        <div className="skill-info">
                            <span>{skill.name}</span>
                            <span className="skill-percentage">{skill.level}%</span>
                        </div>
                        <div className="skill-bar-track">
                            <div
                                className="skill-bar-fill"
                                style={{
                                    width: `${skill.level}%`,
                                    animationDelay: `${index * 0.1}s`
                                }}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SkillMeter;
